import React from 'react';

const Loader = () => {
    return (
        <div className="fixed top-0 left-0 w-screen h-screen bg-black/70 flex justify-center items-center z-[9999] hover:cursor-wait">
            <div 
                className="w-[100px] h-[100px] bg-contain bg-no-repeat animate-bounce"
                style={{ backgroundImage: "url('../../public/img/LogoLight.png')" }}
            ></div>
        </div>
    );
};

export default Loader;